module.exports = __webpack_public_path__ + "static/media/flashcards.397dde94.png";